import type { Context } from 'react';
import { createContext, useContext } from 'react';

import { passthroughRenderer } from './renderer';
import type { RenderGroupReferenceType, RenderUserReferenceType } from './renderer/types';

export interface EntityWrapperContextOptions {
  readonly renderGroupReference: RenderGroupReferenceType;
  readonly renderUserReference: RenderUserReferenceType;
}

export const defaultOptions: EntityWrapperContextOptions = {
  renderGroupReference: passthroughRenderer,
  renderUserReference: passthroughRenderer,
};

export const EntityWrapperContext: Context<EntityWrapperContextOptions> = createContext(defaultOptions);

export type UseEntityWrapperContext = () => EntityWrapperContextOptions;
export const useEntityWrapperContext: UseEntityWrapperContext = () => useContext(EntityWrapperContext);
